export default __webpack_public_path__ + "static/media/Correct-documentation.3196b7ae.md";